/**
 * `Site` enum of brand sites
 */
export var Site;
(function (Site) {
    Site["ALLRECIPES"] = "allrecipes";
    Site["BETTER_HOMES_GARDENS"] = "bhg";
    Site["EATING_WELL"] = "eatingwell";
    Site["FOOD_AND_WINE"] = "foodandwine";
    Site["HEALTH"] = "health";
    Site["MARTHA_LIVING"] = "marthastewart";
    Site["MIDWEST_LIVING"] = "midwestliving";
    Site["MYRECIPES"] = "myrecipes";
    Site["PEOPLE_ESP"] = "peopleenespanol";
    Site["PARENTS"] = "parents";
    Site["RACHAEL_RAY_MAG"] = "rachaelraymag";
    Site["REAL_SIMPLE"] = "realsimple";
    Site["SOUTHERN_LIVING"] = "southernliving";
    Site["SHAPE"] = "shape";
    Site["LOCAL"] = "local";
})(Site || (Site = {}));
